// removed by extract-text-webpack-plugin
module.exports = {"pause":"vL_u","c":"KqFG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pause/index.less
// module id = 259
// module chunks = 0